// extracted by mini-css-extract-plugin
module.exports = {"Container":"CloseBtn_Container__2WPeu","CenterButton":"CloseBtn_CenterButton__HnBEw"};